module.exports = __webpack_public_path__ + "static/fonts/eiconfont.95aad79d.eot";